import type { ModalActionHandler } from './modalActionTypes';
import { unassignJob } from '../map/settlement';
import { getSettlement } from './settlementActionUtils';

export const fireFarmerAction: ModalActionHandler = (state, modal) => {
    const settlement = getSettlement(state, modal);
    if (!settlement || settlement.jobs.farmers <= 0) return false;
    if (!unassignJob(settlement, 'farmers')) return false;
    settlement.production.farm.progress.pop();
    return true;
};
